export default __webpack_public_path__ + "static/media/Group_7469.337094d3.png";